// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SectorAirDetailsTravellerComponent } from './sector-air-details-traveller.component';
import { SectorTravellerModule } from 'libraries/component/booking-information/components/sectors/components/shared/components/sector-traveller/sector-traveller.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { SectorAirServicesServiceModule } from 'libraries/component/booking-information/components/sectors/components/shared/services/sector-air-services/sector-air-services.module';
import { LuggageModule } from 'libraries/luggage/luggage.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        SectorTravellerModule,
        SectorAirServicesServiceModule,
        LoaderModule,
        LuggageModule,
        FontAwesomeModule,
    ],
    exports: [
        SectorAirDetailsTravellerComponent,
    ],
    declarations: [
        SectorAirDetailsTravellerComponent,
    ],
})
export class SectorAirDetailsTravellerModule { }
